import React, { useEffect, useMemo, useState } from 'react';
import { Guide } from '@/pages/home/components/Guide';
import { getLocale, useDispatch, useIntl, useLocation, useSelector } from 'umi';
import translation_filter_cn from './imgs/cn/translation_filter_cn@2x.png';
import translation_filter_en from './imgs/en/translation_filter_en@2x.png';

import review_cn from './imgs/cn/review_cn@2x.png';
import review_en from './imgs/en/review_en@2x.png';

import {
  OPINION_GUIDE_BOX_LIST2,
  OPINION_GUIDE_BOX_LIST2_PATH,
  OPINION_GUIDE_HIDE,
} from '@/pages/home/components/GuideModule/GuideOpinionBox';
import {
  GUIDE_TYPE_OPINION_FEEDS,
  GUIDE_SYS_OPINION,
} from '@/pages/home/models/guide';
import { storage } from '@/utils/utils';

import './index.scss';
import useOpinionGuideData from '@home/components/GuideModule/GuideOpinionBox/useOpinionGuideData';
import { useGetSingePageSourceRule } from '@op/hooks/useGetPageSourceRule';
const GuideComponent = () => {
  const [currentGuideStep, setCurrentGuideStep] = useState(-3);
  const { formatMessage } = useIntl();
  const locale = getLocale();
  const isEn = locale === 'en-US';
  const dispatch = useDispatch();
  const { guideType, userInfo, gameInfo } = useSelector((state: any) => {
    const {
      guide: { guideType },
      home: { userInfo },
      opinionCommon: { gameInfo },
    } = state;
    return {
      guideType,
      userInfo,
      gameInfo,
    };
  });

  const { excludeGuideSource } = useGetSingePageSourceRule({});
  const { GuideData } = useOpinionGuideData({
    gameInfo,
    userInfo,
    guidePermissions: excludeGuideSource,
  });

  // 注意下面两个useEffect不要合并到一起，不然会出现：从头部导航进入新手引导，点击到下一步时，关闭按钮无法关闭，而是返回到第一步
  useEffect(() => {
    if (guideType === GUIDE_TYPE_OPINION_FEEDS) {
      setCurrentGuideStep(0);
    }
  }, [guideType]);

  useEffect(() => {
    const list = storage.getLocalStorageItem(OPINION_GUIDE_BOX_LIST2) || [];
    const guideHide = storage.getLocalStorageItem(OPINION_GUIDE_HIDE);
    if (userInfo?.openid && !list.includes(userInfo.openid) && !guideHide) {
      setCurrentGuideStep(0);
    }
  }, [userInfo]);

  const onFinished = () => {
    if (userInfo.openid) {
      const list = storage.getLocalStorageItem(OPINION_GUIDE_BOX_LIST2) || [];
      !list?.includes(userInfo.openid) && list.push(userInfo.openid);
      storage.setLocalStorageItem(OPINION_GUIDE_BOX_LIST2, list);
    }
    dispatch({
      type: 'guide/showOpinionGuideModule',
      payload: true,
    });
  };

  const onCloseStep = () => {
    dispatch({
      type: 'guide/save',
      payload: {
        guideSys: GUIDE_SYS_OPINION,
        guideType: '',
      },
    });
  };

  const subtitle = formatMessage({
    id: 'Details of Overseas All-Channel Opinions Feeds',
  });
  const { blockList } = GuideData;
  const rank = blockList.findIndex((item) => item.tit === subtitle) + 1;
  const title = `${formatMessage({ id: 'Core Function' })} ${rank}`;

  const steps = useMemo(() => {
    const steps = [
      {
        element: () => document.querySelector('.tea-tabs__tablist'),
        title,
        subtitle,
        description: formatMessage({
          id: 'View Feeds details for each social media platform, game store, and news channel.',
        }),
        placement: 'bottom',
        bubbleStyle: {},
        padding: { paddingLeft: 24, paddingRight: 24 },
      },

      {
        element: () => document.querySelector('.social-media-keyword-box'),
        title,
        subtitle,
        description: formatMessage({
          id: 'Click on any keyword to filter reviews.',
        }),
        placement: 'bottom',
        bubbleStyle: {},
      },

      {
        element: () => document.querySelector('.dbo-translate-select'),
        title,
        subtitle,
        description: formatMessage({
          id: 'All reviews are displayed in their original text and can be translated into either Chinese or English.',
        }),
        placement: 'top',
        bubbleStyle: {},
        extImage: {
          image: isEn ? translation_filter_en : translation_filter_cn,
          placement: 'bottom',
          style: {
            width: 242,
          },
        },
      },

      {
        element: () => document.querySelectorAll('thead th')?.[1],
        title,
        subtitle,
        description: formatMessage({
          id: 'The sentiment score and translation of reviews can be modified, and the modification will take effect the next day.',
        }),
        placement: 'top',
        bubbleStyle: {},
        extImage: {
          image: isEn ? review_en : review_cn,
          placement: 'bottom',
          style: {
            width: 520,
            top: -60,
            position: 'relative',
          },
        },
      },
    ];

    return steps;
  }, [currentGuideStep, formatMessage]);

  if (guideType !== GUIDE_TYPE_OPINION_FEEDS) return null;

  return (
    // finishText 根据中英文调整
    <Guide
      current={currentGuideStep}
      onCurrentChange={(
        current: number,
        context: {
          from: 'start' | 'back' | 'next' | 'finish' | 'cancel' | 'nodata';
        },
      ) => {
        const { from } = context;
        setCurrentGuideStep(current);
        if (from === 'finish' || from === 'nodata') {
          onFinished();
        } else if (from === 'cancel') {
          onCloseStep();
          onFinished();
        }
      }}
      visibleCloseBtn
      hideCancelButton
      showBackButton
      nextButtonTheme="primary"
      backText={formatMessage({ id: 'guide_last_step' })}
      nextText={formatMessage({ id: 'guide_next_step' })}
      finishText={formatMessage({ id: 'guide_more_step' })}
      steps={steps}
      showLoading={false}
    />
  );
};

export default () => {
  const location = useLocation();
  return (
    <>
      {OPINION_GUIDE_BOX_LIST2_PATH === location.pathname && <GuideComponent />}
    </>
  );
};
